import {GET_AVAILABILITY_ERROR} from "../../../reducers/availabilityReducer";


export const getAvailabilityError = (error) =>{
    return {
        type: GET_AVAILABILITY_ERROR,
        payload: {error}
    }
}